import { styled } from '@visualfabriq/vf-ui-kit';

export const StepFooter = styled('div', () => ({
  flex: '0 1 auto',
  display: 'flex',
}));
